import React, { useEffect, useState } from "react";
import Container from "../../common/Container";
import Action from "../../common/Actions"
import "../../index.css";
import SearchIcon from "@mui/icons-material/Search";
import InputWithIcon from "../../common/InputWithIcon";
import { TH, TD, TR, Thead, Tbody } from "../../styled/table";
import Add from "@mui/icons-material/Add";
import Button from "../../common/Button";
import PaginationDiv from "../../common/PaginationDiv";
import CustomAddPage from "../../components/custom-pages/CustomAddModal"
import { createDocument, deleteDocumentById, getAllData } from "../../apis/customApiHandler";
import { convertToIndianTimezoneAndGetDate, handleDownClick, handleUpClick } from "../../utils/helpers";
import { LinearProgress } from "@mui/material";
import checkPermission from "../../utils/checkPermission";

function VehicleModels() {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = React.useState(1);
  const [search, setSearch] = useState("")
  const [vehicleModels, setVehicleModels] = useState([])
  const [vehicleModel, setVehicleModel] = useState({})
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false)
  const currentUser = JSON.parse(localStorage.getItem("user"))


  const getVehicleModel = async () => {
    setLoading(true)
    const data = await getAllData("/master/vehicle/getVehicleModel", {page, limit, search});
    setVehicleModels(data?.data)
    setTotalData(data?.totalData)
    setLoading(false)
  }
  useEffect(() => {
    getVehicleModel();
  }, [search, limit, page])

  const list = [
    {
      name: "Edit",
     condition: checkPermission([
    {
        permission: "masters",
        subPermission: ["UPDATE"]
    },
], currentUser),
      onClick: (Model) => {
        setVehicleModel(Model);
        setShowEditModal(true);
      },
      className: "text-grey",
    },
    {
      name: "Delete",
     condition: checkPermission([
    {
        permission: "masters",
        subPermission: ["DELETE"]
    },
], currentUser),
      onClick: async (Model) => {
        setVehicleModel(Model);
        await createDocument("/master/vehicle/updateVehicleModel?_id=" +  Model?._id, {deleted: true});
                await getVehicleModel()
      },
      className: "text-error",
    },
  ];
  return (
    <Container>
      <div className="flex flex-col md:flex-row justify-between">
        <div className="grid grid-col-1 col-span-2 md:col-span-1 flex flex-col">
          <div className="font-semibold text-[24px]"> Vehicle Models</div>
        </div>

        <div className="flex flex-row text-secondary h-12 gap-3 text-xl">
          <div className="">
            <Button
              text="Add New Vehicle Model"
              disabled = {!checkPermission([
                {
                    permission: "masters",
                    subPermission: ["CREATE"]
                },
            ], currentUser)}
              className="w-full flex flex-row border border-1 border-black items-center px-3 rounded-md h-12 text-[16px] font-medium text-white bg-dark-blue gap-3"
              Icon={<Add color="inherit" />}
              onClick={() => setShowAddModal(true)}
            />
          </div>
        </div>
      </div>
      <div className="mt-5">
        <InputWithIcon
          placeholder="Search for Vehicle Model..."
          variant="outlined"
          setData={setSearch}
          Icon={<SearchIcon className="text-dark-grey" />}
          className="w-80 border border-gray-300 items-center px-2 rounded-md h-12 text-[16px] shadow-sm"
          inputClass="text-[16px]"
        />
      </div>
      <table className="w-full table">
        <Thead className="flex flex-row justify-between w-full">
          <tr className=" flex flex-row justify-between w-full">
            {/* <TH className="" type="checkbox"> <input type="checkbox"></input></TH> */}
            <TH field={"make"}>Vehicle Make</TH>
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setVehicleModels} field={"Make"}>Modal Name</TH>
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setVehicleModels} field={"createdAt"}>Created On</TH>
            <TH>Actions</TH>
          </tr>
        </Thead>
        {loading ? <LinearProgress color="secondary" /> :
          <Tbody className="flex flex-col justify-between w-full">
            {vehicleModels?.length ? vehicleModels?.map((entry, index) => {
              if (true)
                return (
                  <TR className="">
                    {/* <TD className="ml-2 text-center justify-center " type="checkbox"> <input type="checkbox"></input> </TD> */}
                    <TD> {entry.make?.name} </TD>                    
                    <TD> {entry.name} </TD>
                    {/* <TD> {entry.description} </TD>
                    <TD> {entry.numberOfWheels} </TD> */}
                    <TD> {convertToIndianTimezoneAndGetDate(entry.createdAt)} </TD>
                    <TD className="text-center"> <Action list={list} data={entry} /> </TD>
                  </TR>
                );
            }): <div className= "w-full text-semibold text-center text-lightGrey p-3"> No Data Found </div>}
          </Tbody>
        }
      </table>
      <PaginationDiv
        page={page}
        setPage={setPage}
        length={totalData}
        limit={limit}
        setLimit={setLimit}
      />
      {showAddModal && <Create handleClick={async () => { setShowAddModal(false); await getVehicleModel() }} />}
      {showEditModal && <Create data={vehicleModel} handleClick={async () => { setShowEditModal(false); await getVehicleModel() }} />}
    </Container>
  )
}
function Create({ data, handleClick }) {
  const [vehicleMakes, setVehicleMakes] = React.useState([])
  const [initialValues, setInitialValues] = React.useState({
    name: data?.name || "",
    // description: data?.description || "",
    make: data?.make?._id || "",
  });

  const getVehicleMake = async () => {
    const data = await getAllData("/master/vehicle/getVehicleMake", {page: 1, limit: 200});
    setVehicleMakes(data?.data)
  }

  useEffect(()=>{
    getVehicleMake();
  }, [])

  const inputFields = [
    
    // {
    //   name: "description",
    //   label: "Description",
    //   type: "text",
    //   required: true,
    // },
    {
      name: "make",
      label: "Vehicle Make",
      className: "col-span-2",
      type: "select",
      options: vehicleMakes?.map(item => { return {label: item.name, value: item._id}}),
      required: true,
    },
    {
      name: "name",
      label: "Model Name",
      type: "text",
      required: true,
    },
  ];
  return (
    <CustomAddPage
      pageTitle={data ? "Update Vehicle Model" : "Add Vehicle Model"}
      url={data ? "/master/vehicle/updateVehicleModel" : "/master/vehicle/addVehicleModel"}
      action={!data ? "create" : "post"}
      updateId={data?._id}
      queryKey="vehicleModel"
      inputFields={inputFields}
      data={initialValues}
      setData={setInitialValues}
      handleClick={handleClick}
    />
  );
}
export default VehicleModels